import Media, { isVideoUrl } from "@/components/Media";

// Step pictures / how-to videos under an FAQ answer (admin-added, up to 4).
export default function FaqMedia({ media, alt, testid = "faq-media" }) {
  if (!media?.length) return null;
  return (
    <div className={`grid gap-4 mt-5 ${media.length > 1 ? "sm:grid-cols-2" : ""}`} data-testid={testid}>
      {media.map((m, i) => (
        <figure key={m.url + i} className="rounded-2xl overflow-hidden border border-rf-ink/10 bg-rf-cream-alt" data-testid={`${testid}-item-${i}`}>
          <Media
            src={m.url}
            alt={m.caption || alt}
            className="w-auto max-w-full h-auto max-h-[520px] mx-auto object-contain bg-white"
            videoProps={isVideoUrl(m.url) ? { controls: true, autoPlay: false, loop: false } : undefined}
          />
          {m.caption && <figcaption className="px-4 py-2 text-sm text-rf-ink-soft">{m.caption}</figcaption>}
        </figure>
      ))}
    </div>
  );
}
